module.exports = __webpack_public_path__ + "img/4.ad3911e9.jpg";